/**
 * promo-callout
 */

import $ from 'jquery';

// Module dependencies
import 'protons';

// Module styles
// import './_promo-callout.scsss';

// Module template
import './_promo-callout.twig';
import './_promo-callout.scss';

export const name = 'promo-callout';

export const defaults = {
  dummyClass: 'js-promo-callout-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
export function enable($context, { promoCallout = {} }) {
  // Find our component within the DOM
  const $promoCallout = $('.promo-callout', $context);
  // Bail if component does not exist
  if (!$promoCallout.length) {
    return;
  }
  // Merge defaults with incoming settings
  const settings = {
    ...defaults,
    ...promoCallout,
  };
  // An example of what could be done with this component
  $promoCallout.addClass(settings.dummyClass);
}

export default enable;
